import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getVesselTypes() {
  const data = await apiGet('helper/vesselTypes/');
  useHelperStore().setVesselTypes(data);
}
